import { render } from "./orderImport.vue?vue&type=template&id=0b31a09a&scoped=true"
import script from "./orderImport.vue?vue&type=script&lang=js"
export * from "./orderImport.vue?vue&type=script&lang=js"

import "./orderImport.vue?vue&type=style&index=0&id=0b31a09a&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0b31a09a"]])

export default __exports__